import { iconTwitter } from '#src/atoms/icons/system/iconTwitter.ts';
import { OAuthAccount } from '#src/components/settings/OAuthAccount/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

export const TwitterAccount = () => {
  const { currentUser } = useCurrentUserContext();

  if (!currentUser) return null;

  const { twitterUsername } = currentUser.profile;

  return (
    <OAuthAccount
      nickname={twitterUsername ? `@${twitterUsername}` : null}
      provider="twitter"
      icon={iconTwitter}
    />
  );
};
